import {style, animate, trigger, transition, useAnimation, state, animation} from '@angular/animations';

export const slideAnimation = animation([
  style({opacity: '{{start_opacity}}', paddingBottom: '{{start_padding}}', height: '{{start_height}}'}),
  animate('{{time}} ease-out',  style({opacity: '{{end_opacity}}', paddingBottom: '{{end_padding}}', height: '{{end_height}}'}))
],
  { params: { time: '300ms'}});

export const animateShow =
  trigger('animateShow', [
    transition(':enter', useAnimation(slideAnimation, {params: {start_padding: 0, start_opacity: 0, start_height: 0, end_opacity:1, end_padding: '*', end_height:'*'}})),
    transition(':leave', useAnimation(slideAnimation, {params: {start_padding: '*', start_opacity: 1, start_height: '*', end_opacity:0, end_padding: '0', end_height:'0'}})),
  ]);
